// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ydj4eW0yoCY3_edn8ShO{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.ydj4eW0yoCY3_edn8ShO .oBY80M9Uov87O7ZBF3Ga{width:100%;height:100%}.ydj4eW0yoCY3_edn8ShO .Ppi7tNKbDc7KBT3vp6Wo{max-width:1024px;margin:auto;height:100%;display:flex;justify-content:center;flex-direction:column;align-items:center}.ydj4eW0yoCY3_edn8ShO .Ppi7tNKbDc7KBT3vp6Wo .rnuI4C9BluOnQW5UFsPv{flex:0;text-align:bottom}.ydj4eW0yoCY3_edn8ShO .Ppi7tNKbDc7KBT3vp6Wo .e0sO1YApEgm6anFvCNY8{max-width:50%}.ydj4eW0yoCY3_edn8ShO .Ppi7tNKbDc7KBT3vp6Wo ul{margin-top:0}.ydj4eW0yoCY3_edn8ShO .Ppi7tNKbDc7KBT3vp6Wo p{flex:0 0}.ydj4eW0yoCY3_edn8ShO .Ppi7tNKbDc7KBT3vp6Wo strong{font-weight:500}.ydj4eW0yoCY3_edn8ShO h3{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.6rem;text-transform:uppercase}.ydj4eW0yoCY3_edn8ShO h5{margin:0;padding:0;font-size:1em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `ydj4eW0yoCY3_edn8ShO`,
	"rightComponent": `oBY80M9Uov87O7ZBF3Ga`,
	"carouselItem": `Ppi7tNKbDc7KBT3vp6Wo`,
	"title": `rnuI4C9BluOnQW5UFsPv`,
	"infoxBox": `e0sO1YApEgm6anFvCNY8`
};
export default ___CSS_LOADER_EXPORT___;
